export const GOT_VERSION = "GOT_VERSION";
